import request from '@/ajax'

import { appSystem } from "@/utils/index.js"

// import { RecordNativeModule } from './native-module/record-module';


/**
 * 账号密码登录
 * @param {String} username 账号
 * @param {String} password 密码
 */
export async function loginWithUsername(query) {
    let appinfo = {}

    // #ifdef APP
    try {
        appinfo = await RecordNativeModule.getDeviceInfoFull()
    } catch (e) {
    }
    // #endif	
    return request('/Authority/loginByPass', { ...query, ...appinfo });
}
// 账号注册
export async function loginRegister(query) {
    let appinfo = {}
    // #ifdef APP
    try {
        appinfo = await RecordNativeModule.getDeviceInfoFull()
    } catch (e) {
        //TODO handle the exception
    }
    // #endif
    return request('/Authority/register', { ...query, ...appinfo });
}

/**
 * 使用手机号登录
 * @param {String} phone  手机号
 * @param {String} code   验证码
 */
export async function loginWithPhoneNumber(phone, code, data) {
    console.log(phone, code,data);
    
    let obj = { phone, code, ...data }
    let appinfo = {}
    // #ifdef APP 
    try {
        let promote_id = AppNativeModule.getPromoteId()
        if (promote_id) {
            obj.promote_id = promote_id
        }
        appinfo = await RecordNativeModule.getDeviceInfoFull()
    } catch (e) {
        //TODO handle the exception
    }
    // #endif	
    return request('/Authority/loginByPhone', { ...obj, ...appinfo });
}

/**
 * 使用Uni的一键登录
 * @param {String} openid  登录授权唯一标识
 * @param {String} token   接口返回的token
 */
export function loginWithUniCloud(openid, accessToken) {
    let obj = { openid, accessToken }
    return request('/Authority/touchMobuieChuang', obj);
}
/**
 * 闪验一键登录
 * @param {string} token 接口返回的token
 * @returns {Promise<ApiResponse<Logged>>}
 */
export async function loginWithShanYan(token) {
    let obj = { token }
    let appinfo = {}
    // #ifdef APP
    try {
        let promote_id = AppNativeModule.getPromoteId()
        if (promote_id) {
            obj.promote_id = promote_id
        }
        appinfo = await RecordNativeModule.getDeviceInfoFull()
    } catch (e) {
        //TODO handle the exception
    }
    // #endif
    return request('/Authority/touchMobuieChuang', { ...obj, ...appinfo });
}

/**T
 * 获取验证码
 * @param {String} phone  手机号
 * @param {Number} type   验证码类型
 */
//TODO: 39验证码
export function sendSms(query) {
    return request('/Authority/sendPhoneMsg', query);
}

// 获取用户输入用户名手机的验证
export function checkUserNameAndPhone(query) {
    return request('/authority/checkUserNameAndPhone', query);
}
// 验证手机验证码
export function checkPhoneCode(query) {
    return request('/authority/checkPhoneCode', query)
}

// 忘记密码重新设置密码
export function resetPassword(query) {
    return request('/authority/resetPassword', query)
}

// 验证账号
export function checkUsername(query) {
    return request('/Authority/checkUsername', query);
}
